import { render, staticRenderFns } from "./articleSystemList.vue?vue&type=template&id=c9c2b7f2&scoped=true&"
import script from "./articleSystemList.vue?vue&type=script&lang=js&"
export * from "./articleSystemList.vue?vue&type=script&lang=js&"
import style0 from "./articleSystemList.vue?vue&type=style&index=0&id=c9c2b7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c2b7f2",
  null
  
)

export default component.exports